export type BrowserStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
export const ACTIVE_TRIP_KEY = 'ridge-and-road:active-trip';

export function browserStorage(): BrowserStorage | undefined {
  try { return window.localStorage; } catch { return undefined; }
}

/** The old browser-owned trips are deliberately not migrated. Keep the planner key. */
export function clearLegacyTrips(storage = browserStorage()): void {
  for (const key of ['ridge-and-road:trips:v1', 'ridge-and-road:trips:unreadable-backup', 'ridge-and-road:trips:reset-backup']) {
    try { storage?.removeItem(key); } catch { /* Storage can be unavailable; trips now live on the server. */ }
  }
}

export function activeTripId(storage = browserStorage()): string | undefined {
  try { return storage?.getItem(ACTIVE_TRIP_KEY) ?? undefined; } catch { return undefined; }
}

export function rememberActiveTrip(id: string, storage = browserStorage()): void {
  try { storage?.setItem(ACTIVE_TRIP_KEY, id); } catch { /* Only the last-opened selection is lost. */ }
}
